import { render, staticRenderFns } from "./UcFixedAssetTypeBadge.yaml?vue&type=template&id=5dd7cb28&component"
import script from "./UcFixedAssetTypeBadge.yaml?vue&type=script&lang=ts&component"
export * from "./UcFixedAssetTypeBadge.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports